import jwtDecode from 'jwt-decode';

function isPreviewValid(token: string, id: string | number) {
  const now = Math.round(new Date().getTime() / 1000);
  try {
    const jwtData: { id: string | number; exp: number } = jwtDecode(token);
    return jwtData.id === id && jwtData.exp > now;
  } catch (error) {
    return false;
  }
}

export { isPreviewValid };
